export default __webpack_public_path__ + "static/media/P2-Tip-Solution-Blue.1e9b4e28.svg";